'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'cup-straw';
var width = 384;
var height = 512;
var aliases = [129380];
var unicode = 'e363';
var svgPathData = ['M69.4 192L92.2 465.3c.7 8.3 7.6 14.7 15.9 14.7l167.7 0c8.3 0 15.3-6.4 15.9-14.7L314.6 192 69.4 192z', 'M249 0c-22 0-41.2 15-46.6 36.4L179.5 128 16 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l175.7 0c.2 0 .5 0 .7 0L368 160c8.8 0 16-7.2 16-16s-7.2-16-16-16l-155.5 0 21-83.9C235.2 37 241.6 32 249 32l23 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L249 0zM37.3 192l23 276c2.1 24.9 22.9 44 47.8 44l167.7 0c25 0 45.8-19.1 47.8-44l23-276-32.1 0L291.8 465.3c-.7 8.3-7.6 14.7-15.9 14.7l-167.7 0c-8.3 0-15.3-6.4-15.9-14.7L69.4 192l-32.1 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCupStraw = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;